import React, { useState, useEffect, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import services from '../services'
import { PageHeader } from '../../../Common';
import { GoogleMap, LoadScript, Marker, Polyline, InfoWindow } from '@react-google-maps/api';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';
import { split } from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import groupservices from '../../Group/services'
import Map from '../Pages/mapdirection'
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";

const screenCode = "PRODUCTCOLLECTIONROOTMAP";

export function ProductCollectionRouteMap(props) {


    const [title, setTitle] = useState("Collection Point Map View")
    const [isChanged, setIsChanged] = useState(0)
    const [filterMapData, setFilterMapData] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0,
        searchDate: new Date().toISOString().split('T')[0]
    });
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [collectionPoints, setCollectionPoints] = useState();
    const [collectionPointRoutes, setCollectionPointRoutes] = useState();

    const [destination, setDestination] = useState({});
    const [origin, setOrigin] = useState({});

    const containerStyle = {
        width: '1400px',
        height: '600px'
    };

    const center = {
        lat: 6.915056,
        lng: 79.877703
    };

    const position = {
        lat: 6.845851,
        lng: 79.938875
    }
    const [stores, setStores] = useState([])
    const [newStores, setNewStores] = useState([])
    const [istableHidden, setIstableHidden] = useState(false);
    const [isMapVisible, setMapVisible] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });


    const [timeFrame, setTimeFrame] = useState({
        start: "",
        end: ""
    });

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntityByGroupID()
        )
    }, [filterMapData.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointByGroupIDEntityID()
        )
    }, [filterMapData.operationEntityID]);

    function handleGroupChange(e) {

        setFilterMapData({
            ...filterMapData,
            groupID: e.target.value,
            operationEntityID: 0,
            collectionPointID: 0,
        });
    }

    function handleOperationEntityChange(e) {
        setFilterMapData({
            ...filterMapData,
            operationEntityID: e.target.value,
            collectionPointID: 0,

        });
    }

    function handleCollectionPointChange(e) {
        setFilterMapData({
            ...filterMapData,
            collectionPointID: e.target.value,
        });
    }

    function handleDateChange(e) {
        setFilterMapData({
            ...filterMapData,
            searchDate: e.target.value,
        });
    }

    async function getAllGroups() {
        var response = await groupservices.getGroupsForDropdown();
        setGroups(response);
    }

    async function getOperationEntityByGroupID() {
        var response = await services.getAllOperationEntitiesForDropDown(filterMapData.groupID);
        setOperationEntity(response);

    }

    async function getCollectionPointByGroupIDEntityID() {
        var response = await services.GetCollectionPointsFilter(filterMapData.operationEntityID);
        setCollectionPoints(response);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find((p) => p.permissionCode == "VIEWPRODUCTCOLLECTIONMAP");

        if (isAuthorized === undefined) {
            props.history.push("/unauthorized");
        }
        var isGroupFilterEnabled = permissions.find(
            (p) => p.permissionCode == "GROUPDROPDOWN"
        );
        var isOperationEntityFilterEnabled = permissions.find(
            (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
        );
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled != undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled != undefined,
        });
        var token = tokenService.getUserDetailsFromToken();
        setFilterMapData({
            ...filterMapData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID,
        });
        getAllGroups();
    }

    function setLogLang(dataArray) {
        var markers = []
        var infoWindow = []
        var startTime = "";
        var endTime = "";

        dataArray.map((item, index) => {
            var lt = "";
            var long = "";
            var timeArr = item.cardReadTime.split("T");
            if (item.cardReadGPS != null) {
                var gps = item.cardReadGPS;
                var gpsArr = gps.split(',');
                lt = parseFloat(gpsArr[0])
                long = parseFloat(gpsArr[1])
                var data = {
                    lat: lt,
                    lng: long
                }
                var mark = {
                    latitude: lt,
                    longitude: long,
                    readTime: item.cardReadTime,
                    weight: item.totalAmount,
                    numberOfUnits: item.numberOfUnits,
                    customerID: item.customerID,
                    registrationNumber: item.registrationNumber,
                    nameToBePrinted: item.nameToBePrinted,
                    cardReadCategory: item.cardReadCategory,
                    narration: item.narration
                }
                infoWindow.push(mark);
                markers.push(mark);

            } else {
                var mark = {
                    latitude: lt,
                    longitude: long,
                    readTime: item.cardReadTime,
                    weight: item.totalAmount,
                    numberOfUnits: item.numberOfUnits,
                    customerID: item.customerID,
                    registrationNumber: item.registrationNumber,
                    nameToBePrinted: item.nameToBePrinted,
                    cardReadCategory: item.cardReadCategory,
                    narration: item.narration
                }
                infoWindow.push(mark);
                markers.push(mark);
            }
            if (index == 0) {
                setOrigin(data);
                startTime = timeArr[1];
            }
            if (index == dataArray.length - 1) {
                setDestination(data);
                endTime = timeArr[1];
            }
        });
        setStores(markers);
        setNewStores(infoWindow);
        setTimeFrame({
            start: startTime,
            end: endTime
        })
    }

    async function handleSearch(e) {
        e.preventDefault();
        clearMapData();
        const response = await services.filterCollectionPointRoute(filterMapData);
        setMapVisible(true);



        if (response.data.length > 0) {
            setLogLang(response.data);
            setCollectionPointRoutes(response);
            setIstableHidden(true);
        }
        else {
            setIstableHidden(false);
        }
    }

    function clearMapData() {
        setStores([]);
        setNewStores([]);
        setOrigin([]);
        setDestination([]);
    }

    function generateGoogleMapsCanvas() {

        if (isMapVisible) {
            return (istableHidden ?
                <Map markers={stores} destinationX={destination} originX={origin} infoWindow={newStores} time={timeFrame} />
                : <div>No content to preview</div>
            );
        }
    }

    return (

        <div>
            <Fragment>
                <LoadingSpinerComponent />
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <PageHeader
                                title={title}
                                isButtonEnable={false}
                                buttonText="Back to Listing"
                                path="/factories"
                                isChanged={isChanged}
                            />
                            <div className="card-body">
                                <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                    <div className="form-group row">
                                        <div className="col-md pb-1">
                                            <InputLabel shrink id="groupID">Group Name *</InputLabel>
                                            <Select
                                                fullWidth
                                                id="groupID"
                                                name="groupID"
                                                value={filterMapData.groupID}
                                                disabled={!permissionList.isGroupFilterEnabled}
                                                onChange={(e) => handleGroupChange(e)} >
                                                <MenuItem value="0">--Select Group Name--</MenuItem>
                                                {generateDropDownMenu(groups)}
                                            </Select>
                                        </div>

                                        <div className="col-md pb-1">
                                            <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                            <Select
                                                fullWidth
                                                labelId="operationEntityID"
                                                id="operationEntityID"
                                                name="operationEntityID"
                                                value={filterMapData.operationEntityID}
                                                disabled={!permissionList.isOperationEntityFilterEnabled}
                                                onChange={(e) => handleOperationEntityChange(e)}>
                                                <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                                {generateDropDownMenu(operationEntity)}
                                            </Select>
                                        </div>

                                        <div className="col-md pb-1">

                                            <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                            <Select
                                                fullWidth
                                                id="collectionPointID"
                                                name="collectionPointID"
                                                value={filterMapData.collectionPointID}
                                                onChange={(e) => handleCollectionPointChange(e)}>
                                                <MenuItem key="0" value="0">--Select Collection Point--</MenuItem>
                                                {generateDropDownMenu(collectionPoints)}
                                            </Select>
                                        </div>
                                        <div className="col-md pb-1">
                                            <InputLabel shrink id="date">Date</InputLabel>
                                            <TextField
                                                fullWidth
                                                id="date"
                                                name="date"
                                                type="date"
                                                value={filterMapData.searchDate}
                                                onInput={(e) => handleDateChange(e)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <input
                                            type="submit"
                                            className="btn btn-primary"
                                            value="Search" />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                        {generateGoogleMapsCanvas()}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        </div>
    );
}


